import * as React from 'react';
import { Redirect, Link } from 'react-router-dom';
import Accounts from '../accounts/container';
import * as moment from 'moment';
import { isEmpty } from 'lodash';
import Categories from '../shared/categories';
import Loader from '../shared/loader';
import * as $ from 'jquery';
import * as _ from 'lodash';
import colors from '../shared/colors';
import * as classNames from 'classnames';
import formatCurrency from '../services/format.currency';
import { aggregate, getYear } from '../services/expenses.service';
import Row from './row';
import { expenses } from '../shared/categories';
export class Overview extends React.Component<
  { expenses; accounts; user; fetchYearlyExpenses; history },
  { date: Date; year: number; loading: boolean; details: boolean }
> {
  private date: Date;

  constructor(props) {
    super(props);
    this.state = { year: 0, loading: true, details: false } as any;
    const { search } = props.location;
    if (search) {
      this.state = { ...this.state, year: parseInt(new URLSearchParams(search).get('year')) || this.state.year };
    }
    this.state = { ...this.state };
    this.fetchYear();
  }

  fetchYear() {
    this.props.fetchYearlyExpenses(this.state.year).then(() => this.setState({ loading: false }));
  }

  different(dateA, dateB) {
    return isEmpty(dateA) || isEmpty(dateB) || moment(dateA).format('D MMM') !== moment(dateB).format('D MMM');
  }

  renderHeader() {
    const { accounts } = this.props;
    const colorClass = account => classNames('chip center-align', account.color, colors[account.color]);

    return (
      <thead>
        <tr>
          <th />
          <th className="hide-on-small-only" colSpan={this.state.details ? expenses.length + 1 : 4}>
            Expenses
          </th>
          <th className="hide-on-med-and-up">Expenses</th>
          <th>Income</th>
          <th colSpan={Object.keys(accounts).length}>Accounts Change</th>
        </tr>
        <tr>
          <th />
          {!this.state.details && [
            <th className="hide-on-small-only">Yearly</th>,
            <th className="hide-on-small-only">Monthly</th>,
            <th className="hide-on-small-only">Weekly</th>
          ]}
          {this.state.details &&
            expenses.map(e => {
              return <th className="hide-on-small-only">{e}</th>;
            })}
          <th className="hide-on-small-only">Total</th>
          <th className="hide-on-med-and-up" />
          <th />
          {Object.keys(accounts).map(e => {
            return (
              <th className="">
                <div className={colorClass(accounts[e])}>{accounts[e].name}</div>
              </th>
            );
          })}
        </tr>
      </thead>
    );
  }

  renderBody() {
    const { expenses, accounts, user } = this.props;
    const report = aggregate(getYear(expenses, new Date().getFullYear() + this.state.year));
    const months = Object.keys(report).filter(x => !isNaN(Number(x)));
    return (
      <tbody>
        {months.map(month => {
          const value = report[month];
          return (
            <Row
              value={value}
              user={user}
              accounts={accounts}
              year={this.state.year}
              month={month}
              onClick={q => this.props.history.push('/search-expenses?q=' + q)}
              details={this.state.details}
            />
          );
        })}

        <tr>
          <td colSpan={6 + Object.keys(accounts).length}>sum</td>
        </tr>
        <Row
          className="blue-text text-darken-4"
          year={this.state.year}
          value={report}
          user={user}
          accounts={accounts}
          details={this.state.details}
        />
      </tbody>
    );
  }

  render() {
    return (
      <div className="expenses-container">
        <div>
          <div className="center-align">
            <h5>Yearly report</h5>
          </div>
        </div>
        {this.state.details && (
          <div>
            <button
              className="chip center-align light-blue darken-3 grey-text text-lighten-5"
              onClick={() => this.setState({ details: false })}
            >
              Hide details
            </button>
          </div>
        )}
        {!this.state.details && (
          <div>
            <button
              className="chip center-align light-blue darken-3 grey-text text-lighten-5"
              onClick={() => this.setState({ details: true })}
            >
              Show details
            </button>
          </div>
        )}
        <div className="row">
          <div className="col s12">
            <div className="center-align">
              <Link
                className="left waves-effect waves-light"
                to={{
                  search: `?year=${this.state.year - 1}`
                }}
              >
                <i className="material-icons">skip_previous</i>
              </Link>
              <div className="chip center-align light-blue darken-3 grey-text text-lighten-5">
                {moment(new Date(new Date().getFullYear() + this.state.year, 0)).format('YYYY')}
              </div>
              <Link
                className="waves-effect waves-light right"
                to={{
                  search: `?year=${this.state.year + 1}`
                }}
              >
                <i className="material-icons">skip_next</i>
              </Link>
            </div>
            <div className="overflow">
              {!this.state.loading && (
                <table className="highlight payments centered ">
                  {this.renderHeader()}
                  {this.renderBody()}
                </table>
              )}
            </div>
            {this.state.loading && <Loader />}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/overview/component.tsx